export default function Capabilities() {
  const capabilities = [
    {
      icon: 'ri-file-text-line',
      title: 'Digital Infrastructure',
      description: 'Design and operation of scalable web platforms, applications, and digital systems'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Software Development',
      description: 'Internal product development and proprietary technology assets supporting operational efficiency.'
    },
    {
      icon: 'ri-global-line',
      title: 'Media & Distribution',
      description: 'Ownership and management of digital publishing and online media properties.'
    },
    {
      icon: 'ri-building-line',
      title: 'Asset Operations',
      description: 'Strategic capital allocation across cryptocurrency holdings and income-producing real estate assets.'
    }
  ];

  return (
    <section id="capabilities" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] mb-4">
            Core Capabilities
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Diversified operations across digital media, technology, and asset management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#1A2B4A] rounded-full flex items-center justify-center mb-6">
                <i className={`${capability.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2B4A] mb-3">
                {capability.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {capability.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}